import { MeritRatingType } from "../../enum/MeritRatingType";
import { FilePropertiesValidation } from "../../FilePropertiesValidation";
import { MultiLanguage } from "../../MultiLanguage";
import { BaseMeritsType } from '../../enum/BaseMeritsType';
import isEmpty from "lodash/isEmpty";

export class Merit {
    private _meritGroupId: string | null;
    private _id: string;
    private _meritSubGroupId: string | null;
    private _description: MultiLanguage;
    private _helptext: MultiLanguage | null;
    private _score: number;
    private _maxScore: number;
    private _allowCheckExOficio: boolean;
    private _order: number;
    private _ratingType: number;
    private _ratingTypeString: string;
    private _allowUserOficio: boolean;
    private _userOficioComment: string | null;
    private _exOficioDescription: MultiLanguage | null;
    private _userScore: number | null;
    private _userTotalScore: number | null;
    private _rejectionReason: string;
    private _fileProperties: any;
    private _amount: number;
    private _hasMaxScore: boolean;
    private _type: number;
    private _allowDocument: boolean;


    constructor(data: any) {
        this._meritGroupId = data.meritGroupId;
        this._id = data.id;
        this._description = new MultiLanguage(data.description);
        this._meritSubGroupId = data.meritSubGroupId;
        this._helptext = new MultiLanguage(data.helpText);
        this._score = data.score;
        this._maxScore = data.maxScore;
        this._allowCheckExOficio = data.allowCheckExOficio;
        this._order = data.order;
        this._ratingType = data.ratingType;
        this._ratingTypeString = MeritRatingType.translations[data.ratingType]
        this._allowUserOficio = data.oficio;
        this._userOficioComment = data.oficioComment;
        this._exOficioDescription = !isEmpty(data.exOficioDescription) ? new MultiLanguage(data.exOficioDescription) : null;
        this._userScore = data.autoScore ? data.autoScore : data.userScore;
        this._userTotalScore = 0;
        this._rejectionReason = data.rejectionReason;
        this._fileProperties = new FilePropertiesValidation();
        this._amount = data.amount;
        this._hasMaxScore = data.hasMaxScore;
        this._type = data.type || BaseMeritsType.enum.MERIT;
        this._allowDocument = data.allowDocument;
    } 
    public calcTotalScore(meritDocuments) {
        if (this.ratingType === MeritRatingType.enum.FIXED_SCORE) {
            this.calcTotalScoreFixedScore(meritDocuments);
        } else if (this.ratingType === MeritRatingType.enum.INTERVIEW) {
            this.calcTotalScoreInterview(meritDocuments);
        } else {
            if (this.maxScore === null) {
                this.userTotalScore = this.userScore ? this.roundToSix(this.score * Number(this.userScore)) : 0;
            }
            else if (this.maxScore !== null) {
                if (Number(this.score) * Number(this.userScore) > this.maxScore) {
                    this.userTotalScore = this.maxScore;
                    this.hasMaxScore = true;
                } else {
                    this.userTotalScore = this.userScore ? this.roundToSix(this.score * Number(this.userScore)) : 0;
                    this.hasMaxScore = false;
                }
            }
        }
    }

    calcTotalScoreFixedScore(meritDocuments) {
        if (this.allowUserOficio || (Array.isArray(meritDocuments) && meritDocuments.find(element => element.meritId === this.id))) {
            this.userTotalScore = Number(this.score);
            this.userScore = 1;
        } else {
            this.userTotalScore = 0;
            this.userScore = null;
        }
    }

    calcTotalScoreInterview(meritDocuments) {
        if (Array.isArray(meritDocuments) && meritDocuments.find(element => element.meritId === this.id)) {
            this.userScore = 1;
        } else {
            this.userScore = null;
        }
    }

    roundToSix(num) {
        return +(Math.round(Number(num + 'e+6')) + 'e-6');
    }

    public get id(): string {
        return this._id;
    }
    public get meritGroupId(): string | null {
        return this._meritGroupId;
    }
    public get description(): MultiLanguage {
        return this._description;
    }
    public get maxScore(): number {
        return this._maxScore;
    }
    public get score(): number {
        return this._score;
    }
    public get helptext(): MultiLanguage {
        return this._helptext;
    }
    public get allowCheckExOficio(): boolean {
        return this._allowCheckExOficio;
    }
    public get order(): number {
        return this._order;
    }
    public get ratingType(): number {
        return this._ratingType;
    }
    public get ratingTypeString(): string {
        return this._ratingTypeString;
    }

    public get allowUserOficio(): boolean {
        return this._allowUserOficio;
    }
    public get userOficioComment(): string | null {
        return this._userOficioComment;
    }
    public get exOficioDescription(): MultiLanguage {
        return this._exOficioDescription;
    }
    public get userScore(): number {
        return this._userScore;
    }
    public get userTotalScore(): number{
        return this._userTotalScore;
    }
    public get rejectionReason(): string{
        return this._rejectionReason;
    }
    public get fileProperties(): any{
        return this._fileProperties;
    }
    public get amount(): any{
        return this._amount;
    }
    public get hasMaxScore(): boolean{
        return this._hasMaxScore;
    }
    public get type(): number {
        return this._type;
    }
    public get meritSubGroupId(): string | null {
        return this._meritSubGroupId;
    }
    public get allowDocument() {
        return this._allowDocument;
    }

    
    public set allowUserOficio(allowUserOficio: boolean) {
        this._allowUserOficio = allowUserOficio;
    }
    public set userOficioComment(userOficioComment: string | null) {
        this._userOficioComment = userOficioComment;
    }
    public set exOficioDescription(exOficioDescription: MultiLanguage) {
        this._exOficioDescription = exOficioDescription;
    }
    public set userScore(userScore: number) {
        this._userScore = userScore;
    }
    public set userTotalScore(userTotalScore: number){
        this._userTotalScore = userTotalScore;
    }
    public set fileProperties(fileProperties: any){
        this._fileProperties = fileProperties;
    }
    public set hasMaxScore(value: boolean){
        this._hasMaxScore = value;
    }
    public set type(value: number) {
        this._type = value;
    }
    public set meritSubGroupId(meritSubGroupId: string | null ) {
        this._meritSubGroupId = meritSubGroupId;
    }
    public set meritGroupId(meritGroupId: string | null ) {
        this._meritGroupId = meritGroupId;
    }
    public set allowDocument(allowDocument: boolean) {
        this._allowDocument = allowDocument;
    }

    public toServer() {
        return {
            id: this._id,
            meritGroupId: this._meritGroupId,
            meritSubGroupId: this._meritSubGroupId,
            userScore: this._userScore,
            userTotalScore: this._userTotalScore,
            allowUserOficio: this._allowUserOficio,
            userOficioComment: this._userOficioComment,
            type: this._type,
        }
    }
}